import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';

import { AuthorizationGuard } from './core/guard/authorization.guard';
import { AdminShellComponent } from './layout/admin/admin-shell/admin-shell.component';
import { AuthShellComponent } from './layout/auth/auth-shell/auth-shell.component';
import { PageTitleStrategy } from './core/services/page-title-strategy.service';
import { PermissionKey } from './shared/enum/permission-key.enum';
import { SignedInGuard } from './core/guard/signed-in.guard';
import { SignedOutGuard } from './core/guard/signed-out.guard';

const routes: Routes = [
    {
        path: 'login',
        component: AuthShellComponent,
        canActivate: [SignedOutGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
            },
        ],
    },
    {
        path: '',
        component: AdminShellComponent,
        canActivate: [SignedInGuard],
        canActivateChild: [AuthorizationGuard],
        children: [
            {
                path: 'playbooks',
                data: { permission: PermissionKey.PLAYBOOKS },
                loadChildren: () =>
                    import('./playbook/playbook.module').then((m) => m.PlaybookModule),
            },
            {
                path: 'runs',
                data: { permission: PermissionKey.RUNS },
                loadChildren: () => import('./run/run.module').then((m) => m.RunModule),
            },
            {
                path: 'settings',
                loadChildren: () => import('./setting/setting.module').then((m) => m.SettingModule),
            },
            {
                path: '',
                loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
            },
        ],
    },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
    exports: [RouterModule],
    providers: [{ provide: TitleStrategy, useClass: PageTitleStrategy }],
})
export class AppRoutingModule {}
